import * as React from "react";
import { ReferenceInput, required, SelectInput, TextInput, AutocompleteInput } from "react-admin";
import { EditorBuilderInput } from "../../components/input";

import { FileInput } from "src/components/file-input/FileInput";
import { PrivacyEnum, StatusEnum } from "../../common/enum";
import Transformer from "../../common/Transformer";
import { PageEditComponent } from "./PageComponent";
import { Grid } from "@mui/material";
import { Edit, FormTab, TabbedForm } from "src/enterprise/ra-rbac";

export const PageEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "createdBy", "updatedAt", "updatedBy"],
      update: {
        author: data.author.id,
      },
    });

    return data;
  };

  return (
    <Edit
      component={PageEditComponent}
      actions={null}
      mutationMode="pessimistic"
      transform={transform}
    >
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={6}>
              <TextInput disabled source="id" />
            </Grid>
          </Grid>

          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item md={12}>
              <TextInput source="slug" sx={{ marginTop: "8px" }} validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <TextInput source="title" validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <SelectInput source="status" choices={StatusEnum} validate={required()}/>
            </Grid>
            <Grid item sm={12} lg={6}>
              <SelectInput source="privacy" choices={PrivacyEnum} validate={required()} />
            </Grid>
            <Grid item sm={12} lg={6}>
              <ReferenceInput
                source="author.id"
                reference="admin/users"
                filter={{ "roles.like": "ROLE_ADMIN" }}
              >
                <AutocompleteInput
                  optionText={(record) => record.first_name+" "+record.last_name+" ("+record.email+")"}
                  size="small"
                  label="Author"
                  validate={required()}
                />
              </ReferenceInput>
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item md={12}>
              <EditorBuilderInput source="content" required base64 fullWidth validate={[required()]}/>
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="SEO" name="seo">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={8}>
              <TextInput source="meta_title" />
            </Grid>
            <Grid item sm={12} lg={8}>
              <TextInput source="meta_description" multiline rows={4} />
            </Grid>
            <Grid item sm={12} lg={8}>
              <TextInput source="meta_keywords" multiline rows={4} />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Image" name="image">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item>
              <FileInput
                source="image"
                fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
                multiple={false}
              />
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="Custom CSS" name="css">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={12}>
              <TextInput source="css" multiline fullWidth minRows="15" maxRows="30"/>
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};
